import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BsPlayFill, BsPauseFill } from 'react-icons/bs';
import parseTime from '../../util/parseTime';

const MediaUIWrapper = styled.div`
  position: relative;
  margin: 1rem 0 1rem;
  &:after {
    content: '';
    display: table;
    clear: both;
  }
  &.media-ui__video {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 30;
    width: calc(100% - 20px);
    margin: 0 0;
    &:before {
      width: calc(100% + 20px);
      position: absolute;
      left: -10px;
      bottom: -10px;
      background-color: rgba(0,0,0,0.25);
      content: '';
      z-index: -10;
      height: 60px;
    }
  }
`;

const PlayPauseButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  float: left;
  border: none;
  color: var(--custom-red);
  background-color: var(--custom-white);
  font-size: 1.6rem;
  line-height: 0;
  cursor: pointer;
  padding: 0;
`;

const MediaRangeWrapper = styled.div`
  position: absolute;
  width: calc(100% - 110px);
  left: 45px;
  top: 50%;
  transform: translateY(-50%);
`;

const TimeReadout = styled.p`
  width: 50px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
`;

const MediaPlayedBar = styled.div`
  height: 5px;
  display: block;
  width: 0%;
  position: absolute;
  top: 7.5px;
  left: 2px;
  background-color: var(--custom-red);
  border-radius: 3px;
  transition: all 0.1s ease-out;
  pointer-events: none;
  max-width: 100%;
`;

const MediaRange = styled.input`
  width: 100%;
  -webkit-appearance: none;
  background: transparent;
  padding: 8px 0;
  transition: all 0.1s ease-out;
  height: 5px;
  border-radius: 3px;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    background-color: var(--custom-red);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: var(--customShadow);
    margin-top: -6px;
    border: none;
  }
  &::-moz-range-thumb {
    box-shadow: var(--customShadow);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--custom-red);
    cursor: pointer;
    border: none;
  }
  &::-ms-thumb {
    box-shadow: var(--customShadow);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--custom-red);
    cursor: pointer;
    border: none;
  }
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background-color: var(--custom-white);
    border-radius: 3px;
    transition: all 0.1s ease-out;
  }
  &::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background-color: var(--custom-white);
    border-radius: 3px;
  }
  &::-ms-track {
    width: 100%;
    cursor: pointer;
    background: transparent;
    border: none;
    color: transparent;
    height: 5px;
  }
  &::--ms-fill-lower {
    background-color: var(--custom-white)
    border: none;
  }
  &::--ms-fill-upper {
    background-color: var(--custom-white)
    border: none;
  }
`;

const MediaControls = ({
  playMedia,
  maxDuration,
  currentTime,
  changeTime,
  playing,
  progressRef,
  mediaId,
  mediaType,
}) => (
  <MediaUIWrapper className={mediaType !== null ? `media-ui__${mediaType}` : null}>
    <PlayPauseButton type="button" onClick={() => playMedia()}>
      {(playing !== mediaId) && <BsPlayFill />}
      {playing === mediaId && <BsPauseFill />}
    </PlayPauseButton>
    <MediaRangeWrapper>
      <MediaRange
        type="range"
        min="0"
        max={maxDuration * 1000 || 100}
        value={currentTime * 1000 || 0}
        ref={progressRef}
        onChange={() => changeTime()}
      />
      <MediaPlayedBar style={{ width: `${((currentTime * 1000) / (maxDuration * 1000)) * 100}%` }} />
    </MediaRangeWrapper>
    <TimeReadout className="bentonsanscond-n4">{parseTime(currentTime) || '0:00'}/{parseTime(maxDuration) || '-:--'}</TimeReadout>
  </MediaUIWrapper>
);

MediaControls.defaultProps = {
  mediaType: null,
  maxDuration: null,
  currentTime: null,
};

MediaControls.propTypes = {
  playMedia: PropTypes.func.isRequired,
  maxDuration: PropTypes.number,
  currentTime: PropTypes.number,
  changeTime: PropTypes.func.isRequired,
  playing: PropTypes.string.isRequired,
  progressRef: PropTypes.shape().isRequired,
  mediaId: PropTypes.string.isRequired,
  mediaType: PropTypes.string,
};

export default MediaControls;
